import React from 'react';

const AddressCardNew = props => {
  return (
    <div className="infinity-card">
      <div className="infinity-card__new" onClick={props.onClick}>
        <div className="a--blue">+ Add New Address</div>
      </div>
    </div>
  );
};

export default AddressCardNew;



// WEBPACK FOOTER //
// ./src/components/shared/AddressCardNew.js